import { CommonModule, JsonPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../../Model/Combo/combo.service';
import { CommonService } from '../../Model/Common/common.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { ReportsService } from '../../Model/Reports/reports.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { UtilityService } from '../../Model/utility/utility.service';
import moment from 'moment';
import { Router } from '@angular/router';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-regularize-front-log',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, NgbDatepickerModule, JsonPipe,LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './regularize-front-log.component.html',
  styleUrl: './regularize-front-log.component.scss'
})
export class RegularizeFrontLogComponent {
  public User: any = null;
  isDisabled: boolean = false;
  FromDateObj: any = null
  FromDate: any = null
  LogData: any[] = []
  ToDate: any = null;
  ToDateObj: any = null;
  BranchMaster: any[] = [];
  ClientLoad: any[] = [];
  SiteLoad: any[] = [];
  BranchId: any = null; 
  ClientId: any = null; 
  SiteId: any = null; 
  ApprovalStatus: string = 'All';
  EmpCode: string = ''
  constructor(
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    protected common: CommonService,
    private dateFormate: CustomDateParserFormatter,
    private download: DownloadSampleService,
    private report: ReportsService,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
    private router: Router,
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
    this.ComboLoad('Branch');
  }
  Load() {
    if (!this.FromDate) {
      this.toast.show({ message: 'Please select From Date', type: toastTypeEnum.warning });
      return;
    }
    if (!this.ToDate) {
      this.toast.show({ message: 'Please select To Date', type: toastTypeEnum.warning });
      return;
    }
    if (!this.ApprovalStatus || this.ApprovalStatus == '') {
      this.toast.show({ message: 'Please select Approval Status!', type: toastTypeEnum.warning });
      return;
    }
    this.User = this.sessionService.GetUserDetails();
    this.FromDateObj = this.dateFormate.format(this.FromDate);
    this.ToDateObj = this.dateFormate.format(this.ToDate);
    const logdataselect = {
      SelectType: 'AdminWiseRegularizationReport',
      UserId: this.User.UserId,
      FromDate: this.FromDateObj,
      ToDate: this.ToDateObj,
      ApprovalStatus: this.ApprovalStatus,
      BranchId: this.BranchId,
      SiteId: this.SiteId,
      ClientId: this.ClientId,
      EmpType: 'Front',
      EmpCode: this.EmpCode
    }
    this.isDisabled = true;
    this.report.ESS_AdminWiseDetails(logdataselect).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          this.LogData = Object.values(data.Table);
          this.download.exportToExcel(this.LogData, "FrontEmployeeRegularizationReport");
          this.isDisabled = false;
        }
        else {
          this.isDisabled = false;
          this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }
  onSelectChange(type: string) {
    if (type === 'Branch') {
      this.ClientId = 0;
      this.SiteId = 0
    }
    else if (type == 'Client') {
      this.SiteId = null
    }
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.SiteId : 0,
      'IsReport': true
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;

        } else if (Combotype == 'Client') {
          this.ClientLoad = response.ComboLoad;

        } else if (Combotype == 'Site') {
          this.SiteLoad = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }
  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.FromDate = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.ToDate = this.dateFormat.parse(response.Table[0].RegistrationDate);

          this.FromDate.day = 1;
          this.ToDate.day = parseInt(moment(response.Table[0].RegistrationDate).endOf('month').format('D'));
        } 
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close(){
    this.router.navigate(['reports/frontreport']);
  }
}
